import {
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableHeader,
} from "../../../../design/table";
import { Subheading } from "../../../../design/heading";
import EmptyStateView from "../../../../components/EmptyStateView";
import LoadingView from "../../../../components/LoadingView";
import ErrorView from "../../../../components/ErrorView";
import SubtaskListItem from "./SubTaskListItem";
import { useTask } from "../../../../contexts/TaskContext";
import { Task } from "../../../../models/Task";
import SubtaskButton from "../../../../components/SubtaskButton";

interface SubtasksListProps {
  taskId: Task["_id"];
}

const SubtasksList: React.FC<SubtasksListProps> = ({ taskId }) => {
  const { subtasks, loading, error } = useTask();

  if (loading.subtasks) {
    return <LoadingView title="Loading Tasks..." />;
  }

  if (error.subtasks) {
    return <ErrorView error={error.subtasks} />;
  }

  if (!subtasks) {
    return <ErrorView error={new Error("Tasks not found")} />;
  }

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between">
        <Subheading>Subtasks</Subheading>
        <SubtaskButton taskId={taskId} />
      </div>
      {subtasks.length === 0 && (
        <EmptyStateView
          title="No Tasks"
          message="No tasks found. Create an Task to get started."
        />
      )}
      {subtasks.length > 0 && (
        <>
          <Table className="mt-8 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
            <TableHead>
              <TableRow>
                <TableHeader>Title</TableHeader>
                <TableHeader />
              </TableRow>
            </TableHead>
            <TableBody>
              {subtasks.map((subtask) => (
                <SubtaskListItem key={subtask._id} subtask={subtask} />
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </div>
  );
};

export default SubtasksList;
